module.exports = __webpack_public_path__ + "static/img/cont2801.56398f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2801.jpg
// module id = aEE3
// module chunks = 0